import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    refusedLabel: 'Refused',
    replaceDocCta: 'Replace my document',
    title: 'Upload Identity verification (handwritten)',
  },
  fr: {
    refusedLabel: 'Refusé',
    replaceDocCta: 'Remplacer le document',
    title: 'Ajoutez votre attestation d’identité manuscrite',
  },
} as const);
